/**
 * Upload a single File (image or video) to the GridFS-backed media endpoint
 * and return the storefront-relative URL (e.g. /api/media/<id>).
 *
 * The actual fetch is built against REACT_APP_BACKEND_URL with the admin
 * auth token, since axios's default JSON Content-Type breaks multipart.
 */
import axios from "axios";

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") + "/api";

export async function uploadMedia(file) {
  if (!file) throw new Error("No file provided");
  const fd = new FormData();
  fd.append("file", file);
  const token = localStorage.getItem("sdf_token");
  const headers = { "Content-Type": "multipart/form-data" };
  if (token) headers.Authorization = `Bearer ${token}`;
  const { data } = await axios.post(`${API_BASE}/admin/media/upload`, fd, {
    headers,
    // Generous timeout for video uploads on slow networks.
    timeout: 5 * 60 * 1000,
    withCredentials: true,
  });
  return data.url; // /api/media/<id>
}

/**
 * Convenience wrapper for an <input type="file"> change handler.
 * Calls onUploaded(url) once the upload completes.
 */
export function makeMediaUploadHandler(onUploaded, onError) {
  return async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const url = await uploadMedia(file);
      onUploaded?.(url, file);
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || "Upload failed";
      onError?.(msg);
    } finally {
      // Allow re-uploading the same file.
      e.target.value = "";
    }
  };
}
